
import { useState, useCallback } from "react";

export function useDealerModals() {
  const [showPurityModal, setShowPurityModal] = useState(false);
  const [showActivationModal, setShowActivationModal] = useState(false);
  const [showPriceLockModal, setShowPriceLockModal] = useState(false);
  const [selectedMetal, setSelectedMetal] = useState<"ORO" | "ARGENTO">("ORO");

  const handleActivateDealer = useCallback(() => {
    console.log("Activation modal opening");
    setShowActivationModal(true);
  }, []);

  const handlePriceLock = useCallback((metal: "ORO" | "ARGENTO") => {
    console.log(`Price lock modal flow starting for: ${metal}`);
    setSelectedMetal(metal);
    setShowPurityModal(true);
  }, []);

  const handlePuritySelect = useCallback(() => {
    console.log("Purity selected, opening price lock request modal");
    setShowPurityModal(false);
    setShowPriceLockModal(true);
  }, []);

  return {
    showPurityModal,
    setShowPurityModal,
    showActivationModal,
    setShowActivationModal,
    showPriceLockModal,
    setShowPriceLockModal,
    selectedMetal,
    setSelectedMetal,
    handleActivateDealer,
    handlePriceLock,
    handlePuritySelect
  };
}
